export class EventForm {
  constructor() {
    this._root = document.querySelector('.s-event-form')
    if (!this._root) return

    this._onReady = this._onReady.bind(this)
    this._onReady()
    this._root.addEventListener('forminator:form:ready', this._onReady)
    window.setTimeout(this._onReady, 500)
    window.setTimeout(this._onReady, 1500)
  }

  _onReady() {
    this.initPaginationCounter()
    this.observePagination()
    this.initSelectFloatLabel()
    this.initUploads()
    this.fixStepLabels()
    this.initDateMin()
  }

  initDateMin() {
    const input = this._root.querySelector('input[name="date-1"], #date-1-field')
      || this._root.querySelector('.forminator-field-date input')
    if (!input || input.dataset.eventFormDate === '1') return
    input.dataset.eventFormDate = '1'

    const today = new Date()
    const yyyy = today.getFullYear()
    const mm = String(today.getMonth() + 1).padStart(2, '0')
    const dd = String(today.getDate()).padStart(2, '0')
    input.setAttribute('min', `${yyyy}-${mm}-${dd}`)
  }

  fixStepLabels() {
    // La 2e étape est mal libellée dans la config Forminator : on la corrige.
    const label = this._root.querySelector('.forminator-step-1 .forminator-step-label')
    if (label && label.textContent.trim() !== "Informations sur l'événement") {
      label.textContent = "Informations sur l'événement"
    }
  }

  initSelectFloatLabel() {
    this._root.querySelectorAll('.forminator-field-select').forEach((field) => {
      const select = field.querySelector('select')
      if (!select || select.dataset.eventFormSelect === '1') return
      select.dataset.eventFormSelect = '1'

      const placeholder = select.getAttribute('data-placeholder') || ''
      const label = document.createElement('span')
      label.className = 's-event-form__select-label'
      label.textContent = placeholder
      field.querySelector('.forminator-field').prepend(label)

      const sync = () => {
        label.classList.toggle('is-visible', !!select.value)
      }
      select.addEventListener('change', sync)
      // ponytail: select2 réécrit le DOM en async, on resynchronise après son init.
      window.setTimeout(sync, 300)
      sync()
    })
  }

  initUploads() {
    const labels = { 'upload-1': 'Image bannière (1920x600)', 'upload-2': 'Télécharger des pdf' }

    this._root.querySelectorAll('.forminator-field-upload').forEach((wrapper) => {
      if (wrapper.dataset.eventFormUpload === '1') return
      const field = wrapper.querySelector('.forminator-field')
      const input = wrapper.querySelector('input[type="file"]')
      if (!field || !input) return
      wrapper.dataset.eventFormUpload = '1'

      const text = labels[wrapper.id] || (wrapper.querySelector('.forminator-label')?.textContent?.trim() || 'Choisir un fichier')

      const ui = document.createElement('div')
      ui.className = 's-event-form__upload'

      const btn = document.createElement('button')
      btn.type = 'button'
      btn.className = 's-event-form__upload-btn'
      btn.textContent = 'Choisir fichier'

      const span = document.createElement('span')
      span.className = 's-event-form__upload-text'
      span.textContent = text

      ui.appendChild(btn)
      ui.appendChild(span)
      field.prepend(ui)

      btn.addEventListener('click', () => input.click())
      input.addEventListener('change', () => {
        const names = [...(input.files || [])].map((f) => f.name)
        span.textContent = names.length ? names.join(', ') : text
      })
    })
  }

  initPaginationCounter() {
    const pages = this._root.querySelectorAll('.forminator-pagination')
    if (!pages.length) return

    const footer = this._root.querySelector('.forminator-pagination-footer')
      || this._root.querySelector('.forminator-pagination-nav')
      || pages[pages.length - 1]

    if (!footer || footer.querySelector('.s-event-form__page-counter')) return

    const counter = document.createElement('span')
    counter.className = 's-event-form__page-counter'
    counter.setAttribute('aria-live', 'polite')

    // Placé dans le DOM entre précédent et suivant : ← 2/2 → (indépendant de `order`).
    const nextBtn = footer.querySelector('.forminator-button-next')
    if (nextBtn) {
      footer.insertBefore(counter, nextBtn)
    } else {
      footer.appendChild(counter)
    }

    this.updatePageCounter()
  }

  observePagination() {
    const pages = this._root.querySelectorAll('.forminator-pagination')
    const steps = this._root.querySelector('.forminator-pagination-steps')
    if (!pages.length) return

    const observer = new MutationObserver(() => {
      this.updatePageCounter()
      this.fixStepLabels()
    })

    pages.forEach((page) => {
      observer.observe(page, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] })
    })

    if (steps) {
      observer.observe(steps, { childList: true, subtree: true })
    }

    this._root.addEventListener('click', (event) => {
      if (event.target.closest('.forminator-button-back, .forminator-button-next, .forminator-step')) {
        window.setTimeout(() => this.updatePageCounter(), 100)
      }
    })
  }

  updatePageCounter() {
    const pages = [...this._root.querySelectorAll('.forminator-pagination')]
    const counter = this._root.querySelector('.s-event-form__page-counter')
    if (!pages.length || !counter) return

    const visibleIndex = pages.findIndex((page) => {
      const style = window.getComputedStyle(page)
      return style.display !== 'none' && !page.hasAttribute('hidden')
    })

    const current = visibleIndex >= 0 ? visibleIndex + 1 : 1
    counter.textContent = `${current}/${pages.length}`
  }
}
